import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';
import { CurvaAbcVendaSelectComponent } from './curva-abc-venda-referencia-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CurvaAbcVendaSelectComponent
    ],
    exports: [
        CurvaAbcVendaSelectComponent
    ]
})
export class CurvaAbcVendaSelectModule { }
